module.exports = __webpack_public_path__ + "img/jaboatao_background_hero.d5948a20.png";